import styled from '@emotion/styled';
import { layers } from '__app/spacing';
import { fontSizes } from '__app/typography';
import EditableText from '__components/Kizen/EditableText';
import KizenErrorCard from 'components/Kizen/ErrorCard';

export const StyledEditableText = styled(EditableText)`
  align-self: flex-start;
  margin: 0 15px 0 0;
  min-width: 0;
  max-width: 350px;
  input {
    font-size: ${fontSizes.text};
    padding-left: 0;
    // so we can see the placeholder
    &:placeholder-shown {
      min-width: 120px;
    }
  }
`;

export const StyledErrorCard = styled(KizenErrorCard)`
  margin-top: -1px;
  z-index: ${layers.overlay};
`;

export const MobileContainer = styled.div`
  padding: 15px;
  text-align: center;
`;
